/* global $ */
// By default league average type rows will be sorted by the table sorter.
// This takes anything with a `.static` class out of that ordering and places it at the top
$.tablesorter.addWidget({
    id: 'staticRow',
    format(a) {
        if (typeof $(a).data('hasSorted') === 'undefined') {
            $(a).data('hasSorted', true)
            $('tbody .static', a).each(function tableIndex() {
                $(this).data('tableindex', $(this).index())
            })
        } else {
            let b = true
            /* eslint-disable no-loop-func */
            while (b) {
                b = false
                $('tbody .static', a).each(function staticRow() {
                    const c = $(this).data('tableindex')
                    if (c !== $(this).index()) {
                        b = true
                        const d = $(this).detach()
                        const e = $('tbody tr', a).length
                        if (c >= e) {
                            d.appendTo($('tbody', a))
                        } else if (c === 0) {
                            d.prependTo($('tbody', a))
                        } else {
                            d.insertBefore($(`tbody tr:eq(${c})`, a))
                        }
                    }
                })
            }
            /* eslint-enable no-loop-func */
        }
    },
})
